import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalLoaderComponent } from './shared/global-loader/global-loader.component';
import { LoadingService } from './core/services/loading.service';
import {
  NetworkStatus,
  NetworkStatusService,
} from './core/services/network-status.service';
import { AppUpdateService } from './core/services/app-update.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, GlobalLoaderComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'secadm-frontend';

  private readonly destroyRef = inject(DestroyRef);
  private readonly loadingService = inject(LoadingService);
  private readonly networkStatusService = inject(NetworkStatusService);
  private readonly appUpdateService = inject(AppUpdateService);

  readonly showLoader$: Observable<boolean> =
    this.networkStatusService.isOffline$;

  ngOnInit() {
    this.appUpdateService.init();

    this.networkStatusService.status$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((status: NetworkStatus) => {
        if (status === 'offline') {
          this.loadingService.reset();
        }
      });
  }
}
